import React from 'react';
import AvatarWithStatus from '../AvatarWithStatus';

// Custom PowerBI Filter Share Message Component
const PowerBIFilterShareMessage = ({ message }) => {
  // Only render custom UI for filter share messages
  if (!message.attachments || message.attachments.length === 0) {
    return null;
  }
  
  // Check if any attachment is a PowerBI filter share
  const filterAttachment = message.attachments.find(att => att.type === 'pbi_filter_share');
  if (!filterAttachment) {
    return null;
  }
  
  const filterData = filterAttachment;
  
  // Check if required fields are present
  if (!filterData.stateId || !filterData.reportId) {
    console.error('Missing required filter data fields:', filterData);
    return null;
  }
  
  // Count filters and slicers for display
  const filterCounts = filterData.filterCounts || {
    report: filterData.filterState?.reportFilters?.length || 0,
    page: filterData.filterState?.pageFilters?.length || 0,
    visual: filterData.filterState?.visualFilters?.length || 0,
    total: 0
  };
  
  if (!filterCounts.total) {
    filterCounts.total = filterCounts.report + filterCounts.page + filterCounts.visual;
  }
  
  const handleApplyFilters = (event) => {
    event.preventDefault();
    
    try {
      const { stateId, reportId } = filterData;
      

      // Small delay to show feedback
      setTimeout(() => {
        // Navigate to the report with filter state using window.location
        window.location.href = `/report/${reportId}?filterState=${stateId}`;
      }, 200);
    } catch (error) {
      console.error('Error applying filters:', error);
      alert('Failed to apply filters. Please try again.');
    }
  };
  
  // Format the timestamp nicely
  const formattedTime = new Date(filterData.timestamp || message.created_at).toLocaleString(undefined, {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });
  
  // Determine sender name
  const senderName = message.user?.name || message.user?.id || 'User';
  const isCurrentUser = message.user?.id === window.streamChatClient?.user?.id;
  
  return (
    <div className={`flex ${isCurrentUser ? 'justify-end' : 'justify-start'} mb-4 group`}>
      {!isCurrentUser && (
        <div className="mr-3 mt-1 flex-shrink-0">
          <AvatarWithStatus user={message.user} size={32} showStatus={true} />
        </div>
      )}
      <div className="flex flex-col max-w-sm">
        {!isCurrentUser && (
          <div className="text-xs font-medium text-gray-600 mb-1 ml-1">{senderName}</div>
        )}
        
        {/* Filter Share Card */}
        <div className={`rounded-xl overflow-hidden shadow-sm border ${
          isCurrentUser ? 'bg-orange-50 border-orange-200' : 'bg-white border-gray-200'
        }`}>
          {/* Header */}
          <div className={`px-4 py-3 border-b ${
            isCurrentUser ? 'border-orange-200' : 'border-gray-200'
          } flex items-center`}>
            {/* Report Icon */}
            <div className={`w-8 h-8 rounded-full flex items-center justify-center mr-3 ${
              isCurrentUser ? 'bg-orange-200' : 'bg-gray-100'
            }`}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={isCurrentUser ? '#ea580c' : '#6b7280'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
                  <line x1="8" y1="21" x2="16" y2="21"></line>
                  <line x1="12" y1="17" x2="12" y2="21"></line>
                </svg>
              </div>
            <div className="flex-1">
              <h3 className={`font-medium text-sm ${
                isCurrentUser ? 'text-orange-900' : 'text-gray-800'
              }`}>
                {filterData.reportName || 'Shared Report View'}
                </h3>
              <p className={`text-xs ${
                isCurrentUser ? 'text-orange-700' : 'text-gray-500'
              }`}>
                  {filterCounts.total > 0 ? (
                    <span>
                      {filterCounts.total} filter{filterCounts.total !== 1 ? 's' : ''} 
                      {filterCounts.visual > 0 && ` • ${filterCounts.visual} slicer${filterCounts.visual !== 1 ? 's' : ''}`}
                    </span>
                  ) : (
                    <span>Report view</span>
                  )}
                </p>
              </div>
            </div>
            
          {/* Action Button */}
          <div className="p-3">
              <button 
                onClick={handleApplyFilters}
              className={`w-full py-2 px-3 text-sm font-medium rounded-lg transition-colors shadow-sm flex items-center justify-center ${
                isCurrentUser 
                ? 'bg-orange-500 hover:bg-orange-600 text-white' 
                  : 'bg-orange-500 hover:bg-orange-600 text-white'
              }`}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2">
                  <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4M10 17l5-5-5-5M13.8 12H3"></path>
                </svg>
              View with filters
              </button>
            </div>
          </div>
        
         {/* Timestamp */}
        <div className={`flex items-center mt-1 text-xs text-gray-400 ${
          isCurrentUser ? 'justify-end mr-1' : 'ml-1'
        }`}>
            <span>{formattedTime}</span>
        </div>
      </div>
    </div>
  );
};

export default PowerBIFilterShareMessage; 